<template>
  <div
    class="content"
    style="background: #f3f5f9; color: #000000; min-height: 100vh"
  >
    <div class="lottery-bg">
      <div class="lottery-title">
        <van-icon
          name="arrow-left"
          @click="onClickLeft"
          size="20"
          color="#1F2A47"
        />
        <p class="f-w" style="font-size: var(--vk-fs-md); color: #000000">
          {{ $lang.common_txt116 }}
        </p>
        <p></p>
      </div>
    </div>
    <div class="bet-bg">
      <div style="height: 82vh; overflow: scroll">
        <div v-if="readFailed && readOnlyMessage" class="lot-readonly-message">
          {{ readOnlyMessage }}
        </div>
        <div class="bet-bg-t f-w">
          <div class="d-flex-s">
            <img :src="iconUrl" style="width: 100px" />
            <div style="width: 70%; text-align: center">
              <div style="color: #ffffff; font-size: var(--vk-fs-2xl)">
                {{ lotteryName }}
              </div>
              <div class="m-t-10 f-t-18">
                <p
                  style="
                    background: #ffeb00;
                    width: 180px;
                    margin: 0 auto;
                    border-radius: 8px;
                    padding: 5px 0;
                  "
                >
                  {{ issueNo }}
                </p>
              </div>
            </div>
          </div>

          <div v-if="hasDrawingResult" class="m-t-10">
            <div
              v-if="isCryptoLottery(lotteryType)"
              style="
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(11%, 1fr));
                gap: 5px;
                justify-content: start;
              "
            >
              <p
                class="lot-ball"
                v-for="(item, index) in drawingNumbers"
                :key="index"
              >
                {{ item }}
              </p>
              <p
                style="
                  background: #ffeb00;
                  color: #1f2a47;
                  height: 30px;
                  width: 70px;
                  border-radius: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: bold;
                "
                @click="goToBin()"
              >
                {{ $lang.common_txt181 }}
              </p>
            </div>
            <div v-else>
              <div>
                <p class="f-t-15 f-w m-b-5 wihte-color">winning:</p>
                <div class="d-flex" style="flex-flow: wrap row">
                  <p
                    class="lot-ball"
                    v-for="(item2, index) in getResultBalls('winning')"
                    :key="index"
                  >
                    {{ item2 }}
                  </p>
                </div>
              </div>
              <div v-if="hasResultMachine">
                <p class="f-t-15 f-w m-b-5 m-t-5 wihte-color">machine:</p>
                <div class="d-flex" style="flex-flow: wrap row">
                  <p
                    class="lot-ball"
                    v-for="(item2, index) in getResultBalls('machine')"
                    :key="index"
                  >
                    {{ item2 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :style="textStyle(childOrderStatus)"
          style="
            background-size: 100% 100%;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: var(--vk-fs-xl);
            font-weight: bold;
          "
        >
          {{ getStatus(childOrderStatus) }}
        </div>
        <div class="bet-bg-c m-t-15">
          <div class="d-flex-s m-b-10">
            <p class="f-t-15 f-w">{{ $lang.common_txt117 }}</p>
            <ui-icon
              name="refresh"
              :size="22"
              :class="{ rotating: isRotating }"
              style="cursor: pointer"
              @click.native="toggleRotation"
            />
          </div>

          <div class="bet-bg-c2">
            <div class="d-flex-s">
              <p>{{ $lang.common_txt196 }}</p>
              <p class="f-w">
                {{ formatDate(createDate) }}
              </p>
            </div>
            <div class="d-flex-s m-t-20">
              <p>{{ $lang.common_txt120 }}</p>
              <div class="d-flex">
                <p class="f-w">{{ mainOrderNo }}</p>
                <img
                  @click="copyText"
                  width="13px"
                  class="m-l-5"
                  src="../../../assets/img/drawer/drawer_copy.png"
                />
              </div>
            </div>

            <div class="d-flex-s m-t-20">
              <p>{{ $lang.common_txt197 }}</p>
              <p class="f-w f-t-15">
                <span>{{ getCurrency }} </span
                ><span>-{{ mainOrderAmount }}</span>
              </p>
            </div>

            <div class="d-flex-s m-t-20">
              <p>{{ $lang.common_txt198 }}</p>
              <p class="f-w f-t-15">
                <span>{{ getCurrency }} </span
                ><span style="color: #007524">+{{ sendAmount }}</span>
              </p>
            </div>
          </div>
          <div class="bet-bg-c3 m-t-15">
            <p class="f-t-15 f-w title-color m-b-10">
              {{ $lang.common_txt121 }}
            </p>
            <div
              class="bet-bg-c3b"
              v-for="(item, index) in betItemList"
              :key="index"
            >
              <div class="d-flex-s f-t-14" style="margin: 0 15px 10px">
                <p class="m-r-5" style="width: 36%">{{ item.shortForm }}</p>
                <div v-if="item.win" style="width: 30%">
                  <p class="go-win">{{ $lang.common_txt204 }}</p>
                </div>
                <p style="width: 33%; text-align: right" class="f-w">
                  {{ getCurrency }} {{ item.betTimes }}*{{ item.potCount }}
                </p>
              </div>
              <p class="p-line"></p>
              <div
                v-if="
                  item.playType !== 'szc11x6_1x_dwd_zu' &&
                  isCryptoLottery(lotteryType)
                "
                class="f-w f-t-14"
              >
                <div
                  v-if="
                    !['szc11x6_ws_dx_zu', 'szc11x6_ws_ds_zu'].includes(
                      item.playType
                    )
                  "
                  class="bet-bg-c3b2"
                >
                  <p
                    v-for="(item2, index2) in splitBetItem(item.betItem)"
                    :key="index2"
                    :class="{
                      'ac-sel3': isResultHit(item2)
                    }"
                  >
                    {{ item2 }}
                  </p>
                </div>
                <div v-else class="bet-bg-c3b2">
                  <p
                    v-for="(item2, index2) in splitBetItem(item.betItem)"
                    :key="index2"
                    :class="{
                      'ac-sel3': isTailResultHit(item2)
                    }"
                  >
                    {{ item2 }}
                  </p>
                </div>
              </div>
              <div v-else class="bet-bg-c3b2 f-w f-t-14">
                <p
                  v-for="(item2, index2) in splitBetItem(item.betItem)"
                  :key="index2"
                  :class="{
                    'ac-sel3': isResultHit(item2, 'winning')
                  }"
                >
                  {{ item2 }}
                </p>
              </div>

              <div
                v-if="item.playType === 'szc11x6_1x_dwd_zu'"
                class="bet-bg-c3b2 f-w f-t-14"
              >
                <div>
                  <div class="d-flex">
                    <p
                      style="
                        background: #bed730;
                        color: #038141;
                        border-radius: 10px;
                        border: none !important;
                        padding: 12px;
                        width: 30px;
                        margin-right: 10px;
                      "
                      v-for="(item, index) in [1, 2, 3, 4, 5, 6]"
                      :key="index"
                    >
                      {{ item }}
                    </p>
                  </div>
                  <div class="m-t-10" style="display: flex">
                    <div
                      class="m-b-5"
                      v-for="(item2, index2) in splitBetColumns(item.betItem)"
                      :key="index2"
                    >
                      <p
                        style="
                          margin-bottom: 5px;
                          border: 50%;
                          margin-right: 10px;
                        "
                        :style="{
                          border: ['*'].includes(item3.toString())
                            ? 'none'
                            : '1px solid'
                        }"
                        v-for="(item3, index3) in splitResult(item2)"
                        :key="index3"
                        :class="
                          isResultAtIndex(item3, index2)
                            ? 'ac-sel'
                            : ''
                        "
                      >
                        {{ item3 }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="margin-top: 10px; line-height: 20px"
                class="f-w f-t-14"
              >
                <div v-if="item.win" class="m-l-10">
                  {{ $lang.common_txt176 }}: {{ getCurrency
                  }}<span style="color: #007524">
                    {{ item.bonusAmount }}
                  </span>
                </div>
                <div
                  class="m-t-5"
                  style="
                    background: #3979e3;
                    padding: 7px 10px;
                    border-radius: 0 0 13px 13px;
                    color: #ffffff;
                  "
                >
                  <span style="color: #ffeb00"> {{ item.betTimes }} </span>
                  {{ $lang.common_txt205 }}
                  <span style="color: #ffeb00">{{ item.potCount }}</span>
                  {{ $lang.common_txt206 }}
                  <span style="color: #ffeb00"
                    >{{ getCurrency }} {{ item.betAmount }} </span
                  >.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bet-bot">
        <div
          class="btn1"
          @click="goToDe(1)"
          :class="{ 'lot-wiht': childOrderStatus !== 'bet_child$draw_waiting' }"
        >
          {{ $lang.common_txt126 }}
        </div>
        <div
          v-if="childOrderStatus === 'bet_child$draw_waiting'"
          class="btn2"
          @click="goToDe(2)"
        >
          {{ $lang.common_txt127 }}
        </div>
      </div>
    </div>

    <common-popup
      v-model="showPopup"
      :config="{
        content: $lang.common_txt161,
        bt1: $lang.Cancelar,
        bt2: $lang.Confirmar
      }"
      @close="close"
      @confirm="confirm"
    ></common-popup>
  </div>
</template>
<script>
import { BetDetail, CancelBet } from '@/api/common'
import { isCryptoLotteryType } from '@/views/layout/lotteryCatalog'
import { openExternalUrl } from '@/views/layout/safeLayout'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { copyTextToClipboard } from '@/components/share/shareSafety'
import {
  hasLotteryWriteProof,
  isLotteryNeedLoginResponse,
  isLotteryOkResponse,
  isLotteryReadOnlyQueryResponse,
  isLotteryReadableResponse,
  lotteryResponseBody,
  lotteryResponseMessage
} from './lotteryResponse'
import { parseLotteryResult, splitLotteryResult } from './lotteryResultSafety'

function guardedLocalStorage() {
  try {
    return safeLocalStorage()
  } catch (e) {
    return null
  }
}

function routeQuery(vm) {
  return vm && vm.$route && vm.$route.query && typeof vm.$route.query === 'object'
    ? vm.$route.query
    : {}
}

function safeJumpTo(vm, ...args) {
  if (vm && typeof vm.$jumpTo === 'function') {
    vm.$jumpTo(...args)
  }
}

function safeRouterGo(vm, delta) {
  if (vm && vm.$router && typeof vm.$router.go === 'function') {
    vm.$router.go(delta)
  }
}

export default {
  name: 'bettingDetails',
  components: {},
  data() {
    return {
      memberList: [
        this.$lang.common_txt99,
        this.$lang.common_txt100,
        this.$lang.common_txt101,
        this.$lang.common_txt102,
        this.$lang.common_txt103,
        this.$lang.common_txt104,
        this.$lang.common_txt105,
        this.$lang.common_txt106,
        this.$lang.common_txt107,
        this.$lang.common_txt108,
        this.$lang.common_txt109,
        this.$lang.common_txt110
      ],
      showPopup: false,
      lotteryName: '',
      issueNo: '',
      drawingResult: [],
      mainOrderAmount: 0,
      createDate: '',
      mainOrderNo: '',
      betItemList: [],
      childOrderStatusName: '',
      lotteryType: '',
      childOrderStatus: '',
      uid: 0,
      sendAmount: 0,
      iconUrl: '',
      resultBasedOn: '',
      isRotating: false,
      readOnlyQuery: false,
      readFailed: false,
      readOnlyMessage: ''
    }
  },
  computed: {
    drawingNumbers() {
      return this.splitResult(this.drawingResult)
    },
    hasDrawingResult() {
      return this.drawingNumbers.length > 0 || this.getResultBalls('winning').length > 0
    },
    hasResultMachine() {
      return this.getResultBalls('machine').length > 0
    }
  },
  mounted() {
    this.BetDetail()
  },
  methods: {
    firstValue(...values) {
      const hit = values.find((value) => value !== undefined && value !== null && value !== '')
      return hit === undefined ? '' : hit
    },
    responseBody(data) {
      return lotteryResponseBody(data)
    },
    responseErrorPayload(error) {
      if (!error) return error
      if (error.status !== undefined || error.code !== undefined || error.content || error.payload || error.extra || error.page) {
        return error
      }
      return error && (
        (error.response && (error.response.data || error.response.body)) ||
        error.data ||
        error.body ||
        error.content ||
        error
      )
    },
    pickList(source, keys = []) {
      const body = source && source.status ? this.responseBody(source) : source
      const names = keys.concat(['betItemList', 'schemeList', 'itemList', 'list', 'records'])
      const search = (target) => {
        if (!target || typeof target !== 'object') return []
        if (Array.isArray(target)) return target
        for (const key of names) {
          if (Array.isArray(target[key])) return target[key]
        }
        for (const key of ['content', 'payload', 'extra', 'page', 'data', 'body']) {
          const list = search(target[key])
          if (list.length) return list
        }
        return []
      }
      return this.safeList(search(body))
    },
    safeList(list) {
      return Array.isArray(list) ? list : []
    },
    safeNumber(value) {
      const num = Number(value)
      return Number.isFinite(num) ? num : 0
    },
    safeToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    },
    hasLogin() {
      return !!safeGetStorageItem(guardedLocalStorage(), 'token')
    },
    formatDate(value) {
      if (!value) return '--'
      const date = this.$dayjs(value)
      return date && date.isValid && date.isValid()
        ? date.format('DD/MM/YYYY HH:mm:ss')
        : String(value)
    },
    showNeedLogin() {
      this.safeToast({
        message: this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now',
        icon: 'fail'
      })
      safeJumpTo(this, '/home', {}, { replace: true })
    },
    splitResult(value) {
      return splitLotteryResult(value, { extractNumbers: true })
    },
    parseDrawingResult() {
      return parseLotteryResult(this.drawingResult)
    },
    getResultBalls(key = 'winning') {
      const result = this.parseDrawingResult()
      return this.splitResult(result && typeof result === 'object' ? result[key] : '')
    },
    isCryptoLottery(type) {
      return isCryptoLotteryType(type)
    },
    isResultHit(value, key) {
      const balls = key ? this.getResultBalls(key) : this.drawingNumbers.concat(this.getResultBalls('winning'))
      return balls.includes(String(value))
    },
    isTailResultHit(value) {
      const last = this.drawingNumbers[this.drawingNumbers.length - 1] || ''
      return last.includes(String(value))
    },
    isResultAtIndex(value, index) {
      return String(this.drawingNumbers[index] || '') === String(value)
    },
    splitBetItem(value) {
      if (!value) return []
      return String(value)
        .split('@')[0]
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    },
    splitBetColumns(value) {
      if (!value) return []
      return String(value)
        .split('@')[0]
        .split('#')
        .map((item) => item || '*')
    },
    normalizeBetItem(item = {}) {
      const bonusAmount = this.safeNumber(
        this.firstValue(item.bonusAmount, item.winAmount, item.sendAmount)
      )
      const playType = this.firstValue(item.playType, item.play_type)
      return {
        ...item,
        shortForm: this.firstValue(
          item.shortForm,
          item.shortFormName,
          item.playTypeName,
          item.playName,
          playType,
          '--'
        ),
        playType,
        betItem: this.firstValue(item.betItem, item.bet_item, item.content),
        betTimes: this.safeNumber(item.betTimes || item.bet_times || 1),
        potCount: this.safeNumber(item.potCount || item.pot_count || 1),
        betAmount: this.safeNumber(item.betAmount || item.amount),
        bonusAmount,
        win: !!item.win || bonusAmount > 0
      }
    },
    normalizeDetail(content = {}) {
      return {
        lotteryName: this.firstValue(content.lotteryName, content.lottery_name, content.gameName),
        issueNo: this.firstValue(content.issueNo, content.issue_no),
        drawingResult: this.firstValue(
          content.drawingResult,
          content.lotteryResult,
          content.lottery_result,
          content.openCode,
          content.result
        ),
        mainOrderAmount: this.safeNumber(
          this.firstValue(content.mainOrderAmount, content.betAmount, content.bet_amount)
        ),
        createDate: this.firstValue(content.createDate, content.betTime, content.create_date),
        mainOrderNo: this.firstValue(content.mainOrderNo, content.betOrderNo, content.orderNo),
        betItemList: this.pickList(content, [
          'betItemList',
          'schemeList',
          'itemList',
          'list',
          'records'
        ]).map(this.normalizeBetItem),
        childOrderStatusName: this.firstValue(
          content.childOrderStatusName,
          content.orderStatusName,
          content.statusName
        ),
        lotteryType: this.firstValue(content.lotteryType, content.lottery_type, content.gameCode),
        childOrderStatus: this.firstValue(
          content.childOrderStatus,
          content.orderStatus,
          content.statusCode,
          content.status
        ),
        uid: this.firstValue(content._uid, content.uid),
        sendAmount: this.safeNumber(
          this.firstValue(content.sendAmount, content.winAmount, content.bonusAmount)
        ),
        iconUrl: this.firstValue(content.iconUrl, content.icon_url),
        resultBasedOn: this.firstValue(content.resultBasedOn, content.result_based_on)
      }
    },
    toggleRotation() {
      if (this.isRotating) return // 如果已经在旋转，直接返回
      this.isRotating = true
      // 动画结束后重置状态
      setTimeout(() => {
        this.isRotating = false
      }, 1000) // 动画持续时间
      this.BetDetail()
    },

    goToBin() {
      if (!this.resultBasedOn) return
      openExternalUrl(this.resultBasedOn)
    },
    textStyle(v) {
      if (v === 'bet_child$no_win') {
        return {
          backgroundImage: `url(${require('@/assets/img/lottery/lotd_3.png')})`
        }
      } else if (v === 'bet_child$refunded_u') {
        return {
          backgroundImage: `url(${require('@/assets/img/lottery/lotd_2.png')})`
        }
      } else if (v === 'bet_child$sent') {
        return {
          backgroundImage: `url(${require('@/assets/img/lottery/lotd_1.png')})`
        }
      } else if (v === 'bet_child$refunded_s') {
        return {
          backgroundImage: `url(${require('@/assets/img/lottery/lotd_2.png')})`
        }
      } else if (v === 'bet_child$draw_waiting') {
        return {
          backgroundImage: `url(${require('@/assets/img/lottery/lotd_4.png')})`
        }
      }
    },
    getStatus(v) {
      if (v === 'bet_child$no_win') {
        return this.$lang.common_txt199
      } else if (v === 'bet_child$refunded_u') {
        return this.$lang.common_txt200
      } else if (v === 'bet_child$sent') {
        return this.$lang.common_txt201
      } else if (v === 'bet_child$refunded_s') {
        return this.$lang.common_txt202
      } else if (v === 'bet_child$draw_waiting') {
        return this.$lang.common_txt203
      }
    },
    copyText() {
      try {
        const copied = copyTextToClipboard(this.mainOrderNo)
        this.safeToast({
          message: copied ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
          icon: copied ? 'success' : 'cross'
        })
      } catch (e) {
        this.safeToast({
          message: this.$lang.copy_failed || 'Copy failed',
          icon: 'cross'
        })
      }
    },
    onClickLeft() {
      const query = routeQuery(this)
      if (query.type === 'y') {
        if (!this.hasLogin()) {
          safeJumpTo(this, '/home', {}, { replace: true })
          return
        }
        safeJumpTo(
          this,
          './lotteryDetail',
          {
            lotteryType: query.lotteryType,
            lotteryName: query.lotteryName
          },
          { replace: true }
        )
      } else {
        safeRouterGo(this, -1)
      }
    },
    confirm() {
      this.CancelBet()
    },
    close() {
      this.showPopup = false
    },
    collectResponseBodies(source, depth = 0, out = []) {
      if (!source || typeof source !== 'object' || depth >= 4) return out
      out.push(source)
      ;['content', 'payload', 'extra', 'page', 'data', 'body'].forEach((key) => {
        const value = source[key]
        if (value && typeof value === 'object') {
          this.collectResponseBodies(value, depth + 1, out)
        }
      })
      return out
    },
    isCancelStatus(value) {
      const token = String(value == null ? '' : value).trim().toLowerCase()
      return [
        'bet_child$refunded_u',
        'bet_child$refunded_s',
        'cancelled',
        'canceled',
        'cancel',
        'refunded',
        'refund',
        'refunded_u',
        'refunded_s'
      ].includes(token)
    },
    hasCancelProof(response) {
      const bodies = this.collectResponseBodies(response)
      const content = this.responseBody(response)
      if (content && typeof content === 'object') bodies.push(content)
      return bodies.some((body) => {
        if (!body || typeof body !== 'object') return false
        if ([
          body.cancelled,
          body.canceled,
          body.cancelSuccess,
          body.cancel_success,
          body.refunded,
          body.refundSuccess,
          body.refund_success
        ].some((value) => value === true || value === 1 || String(value).toLowerCase() === 'true')) {
          return true
        }
        if ([
          body.cancelProof,
          body.cancel_proof,
          body.cancelOrderNo,
          body.cancel_order_no,
          body.refundOrderNo,
          body.refund_order_no
        ].some((value) => value !== undefined && value !== null && String(value).trim())) {
          return true
        }
        return [
          body.childOrderStatus,
          body.orderStatus,
          body.statusCode,
          body.status,
          body.state,
          body.result
        ].some(this.isCancelStatus)
      })
    },
    isCancelConfirmed(response) {
      return this.hasCancelProof(response) || this.isCancelStatus(this.childOrderStatus)
    },
    async CancelBet() {
      if (!this.hasLogin()) {
        this.showNeedLogin()
        return
      }
      try {
        const data = await CancelBet({
          lotteryType: this.lotteryType,
          mainOrderNo: this.mainOrderNo,
          uid: this.uid
        })
        if (isLotteryNeedLoginResponse(data)) {
          this.showNeedLogin()
        } else if (isLotteryOkResponse(data) && hasLotteryWriteProof(data)) {
          let refreshed = false
          if (!this.isCancelConfirmed(data)) {
            refreshed = await this.BetDetail()
          }
          if (this.isCancelConfirmed(data)) {
            this.showPopup = false
            if (!refreshed) this.BetDetail()
          } else {
            this.safeToast({
              message: lotteryResponseMessage(data, this.$lang.common_txt161),
              icon: 'cross'
            })
          }
        } else {
          this.safeToast({
            message: lotteryResponseMessage(data, this.$lang.common_txt161),
            icon: 'cross'
          })
        }
      } catch (error) {
        this.safeToast({
          message: this.$lang.common_txt161,
          icon: 'cross'
        })
      }
    },
    goToDe(v) {
      if (v === 1) {
        if (!this.hasLogin()) {
          this.showNeedLogin()
          return
        }
        safeJumpTo(
          this,
          '/lotteryDetail',
          {
            lotteryType: this.lotteryType,
            lotteryName: this.lotteryName
          },
          { replace: true }
        )
      } else {
        if (!this.hasLogin()) {
          this.showNeedLogin()
          return
        }
        if (this.readOnlyQuery || this.readFailed) {
          if (typeof this.$toast === 'function') {
            this.$toast({
              message: this.readOnlyMessage || this.$lang.common_txt161,
              icon: 'cross'
            })
          }
          return
        }
        this.showPopup = true
      }
    },
    async BetDetail() {
      if (!this.hasLogin()) {
        this.showNeedLogin()
        return
      }
      try {
        const query = routeQuery(this)
        const data = await BetDetail({
          childOrderNo: query.childOrderNo,
          mainOrderNo: query.mainOrderNo
        })
        this.readOnlyQuery = isLotteryReadOnlyQueryResponse(data)
        this.readFailed = false
        if (isLotteryNeedLoginResponse(data)) {
          this.readFailed = true
          this.readOnlyMessage = lotteryResponseMessage(
            data,
            this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
          )
          this.showNeedLogin()
        } else if (isLotteryReadableResponse(data)) {
          this.readOnlyMessage = ''
          const content = this.responseBody(data)
          const detail = this.normalizeDetail(
            content.detail || content.order || content.record || content
          )
          this.lotteryName = detail.lotteryName
          this.issueNo = detail.issueNo
          this.drawingResult = detail.drawingResult
          this.mainOrderAmount = detail.mainOrderAmount
          this.createDate = detail.createDate
          this.mainOrderNo = detail.mainOrderNo
          this.betItemList = detail.betItemList
          this.childOrderStatusName = detail.childOrderStatusName
          this.lotteryType = detail.lotteryType
          this.childOrderStatus = detail.childOrderStatus
          this.uid = detail.uid
          this.sendAmount = detail.sendAmount
          this.iconUrl = detail.iconUrl
          this.resultBasedOn = detail.resultBasedOn
          return true
        } else {
          this.readFailed = true
          this.readOnlyMessage = lotteryResponseMessage(data, this.$lang.common_txt376 || this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.')
          if (typeof this.$toast === 'function') {
            this.$toast({
              message: this.readOnlyMessage,
              icon: 'cross'
            })
          }
        }
      } catch (error) {
        this.readFailed = true
        const payload = this.responseErrorPayload(error)
        if (isLotteryNeedLoginResponse(payload)) {
          this.readOnlyMessage = lotteryResponseMessage(
            payload,
            this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
          )
          this.showNeedLogin()
          return false
        }
        this.readOnlyMessage = lotteryResponseMessage(
          payload,
          this.$lang.common_txt376 || this.$lang.noempt || 'This feature is temporarily unavailable. Please try again later.'
        )
        if (typeof this.$toast === 'function') {
          this.$toast({
            message: this.readOnlyMessage,
            icon: 'cross'
          })
        }
      }
      return false
    }
  }
}
</script>
<style lang="less" scoped>
.bet-bg {
  padding: 3% 3% 13%;
}
.lot-readonly-message {
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff7e6;
  color: #9a5b00;
  font-size: var(--vk-fs-sm);
  line-height: 1.4;
}
.bet-bg-t {
  // background: url(../../../assets/img/lottery/lotty-debg.png) no-repeat;
  // background: @cont-bg;
  background: linear-gradient(to bottom, #3f81ee, #2f6cd0);
  border-radius: 20px;
  background-size: 100% 100%;
  width: 100%;
  // height: 110px;
  margin-bottom: 10px;
  padding: 15px;
}
.bet-bg-t2 {
  background: #f7d827;
  font-weight: bold;
  padding: 2px 0;
  width: 100px;
  text-align: center;
  border-radius: 5px;
  color: #000000;
  font-size: var(--vk-fs-15);
  margin-top: 5px;
}
.lot-ball {
  // background: #f8ff3b;
  background: url('../../../assets/img/lottery/select-q.png') no-repeat;
  // background: @cont-bg;
  border-radius: 20px;
  background-size: 100% 100%;
  width: 32px;
  height: 32px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: var(--vk-fs-xs);
  margin-right: 10px;
}
.bet-bg-c2 {
  padding: 15px;
  border-radius: 13px;
  // background: linear-gradient(to right, #425031, #394234, #323738);
  background: #ffffff;
}
.bet-bg-c3b {
  padding: 15px 0 0;
  border-radius: 13px;
  // background: linear-gradient(to right, #4b4030, #3d3b34, #313637);
  background: #ffffff;
  margin-bottom: 12px;
}
.p-line {
  height: 1px;
  background: #f3f3f3;
}
.bet-bg-c3b2 {
  margin: 15px 10px 10px 10px;
  // display: flex;
  // align-items: center;
  // flex-flow: wrap row;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(9%, 1fr));
  gap: 5px;
  justify-content: start;
  p {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #000000;
  }
}
.bet-bot {
  position: fixed;
  bottom: 15px;
  margin: 0 auto;
  display: flex;
  width: 94%;
  justify-content: space-between;
  .btn1 {
    // background: linear-gradient(to right, #92e778, #80e980, #6cec88);
    background: #3979e3;
    border-radius: 10px;
    // border-bottom: 2px solid #2fb25d;
    width: 45%;
    padding: 15px 0;
    color: #ffffff;
    text-align: center;
    font-size: var(--vk-fs-15);
    font-weight: bold;
  }
  .btn2 {
    // background: linear-gradient(to right, #e67676, #e46060, #e14c4c);
    background: #d62945;
    border-radius: 10px;
    // border-bottom: 2px solid #b22f2f;
    width: 45%;
    padding: 15px 0;
    color: #ffffff;
    text-align: center;
    font-size: var(--vk-fs-15);
    font-weight: bold;
  }
}
.lot-wiht {
  width: 100% !important;
}
.lot-right {
  background: url('../../../assets/img/lottery/right-lot.png') no-repeat;
  background-size: 100% 100%;
  width: 135px;
  height: 90px;
  p {
    color: #f7d827;
    text-shadow: 1px 0 0 #7f5322, /* 右侧边框 */ -1px 0 0 #7f5322,
      /* 左侧边框 */ 0 1px 0 #7f5322, /* 下方边框 */ 0 -1px 0 #7f5322; /* 上方边框 */
    text-align: center;
    padding-top: 61px;
  }
}
.lottery-bg {
  position: sticky;
  top: 0;
  z-index: 999;
}
.lottery-title {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 0 16px;
  // box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
}
.lot-gn-t {
  position: fixed;
  top: 55px;
  z-index: 9;
  right: 0;
  background: #333738;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.6);
  padding: 10px;
}
.ac-sel {
  background: #ed0000 !important;
  color: #ffffff;
  border: 1px solid #ed0000 !important;
}
.ac-sel2 {
  background: url(../../../assets/img/lottery/hua_s.png) no-repeat !important;
  color: #737c7d !important;
  background-size: 100% 100% !important;
  width: 30px !important ;
  height: 30px !important;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mili-select {
  background: url(../../../assets/img/lottery/hua.png) no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.lot_hh {
  background: url(../../../assets/img/lottery/hua_s.png) no-repeat;
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}
.ac-sel3 {
  color: #ffffff;
  background: #ed0000;
  border: 1px solid #ed0000 !important;
}
.go-win {
  background: url('../../../assets/img/lottery/lot_gho.png') no-repeat;
  background-size: 100% 100%;
  width: 72px;
  color: #ffffff;
  text-align: center;
  height: 22px;
  margin-top: -26px;
}
/* 定义旋转动画 */
@keyframes rotate-and-back {
  0%,
  100% {
    transform: rotate(0deg); /* 初始和最终状态 */
  }
  50% {
    transform: rotate(360deg); /* 顺时针旋转360度 */
  }
}
/* 动画类 */
.rotating {
  animation: rotate-and-back 1s linear forwards; /* 4秒完成动画，线性过渡，动画结束后保留状态 */
}
</style>
